module.exports = __webpack_public_path__ + "static/media/two-students.77ae982c.jpg";